export default "__VITE_ASSET__Ci324948__"